<template>
  <van-popup
    v-model="visible"
    position="bottom"
    :style="{ height: '80%' }"
    closeable
    close-icon-position="top-right"
    @close="close"
  >
    <div class="protocol-content" v-html="protocolHtml"></div>
  </van-popup>
</template>

<script>
export default {
  name: "ProtocolPopup",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
  },
  data() {
    return {
      protocolHtml: `
        <div style="padding: 20px 16px; font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif; color: #1a1a1a; line-height: 1.8;">
          <h2 style="text-align: center; font-size: 22px; font-weight: 700; margin-bottom: 24px;">灵活就业服务协议</h2>

          <p><strong>甲方（平台方）</strong></p>
          <p>漯河捷泰信息科技有限公司</p>
          <p><strong>乙方（灵活就业人员）</strong></p>
          <p>姓名：_____________________________</p>
          <p>身份证号码：_____________________________</p>

          <h3 style="font-weight: 700; margin-top: 24px;">一、协议宗旨</h3>
          <p>依据《中华人民共和国民法典》《中华人民共和国电子商务法》等相关法律法规，甲乙双方本着平等自愿、公平诚信的原则，就乙方通过甲方灵活用工平台承接服务项目、甲方为乙方提供配套服务事宜，订立本协议，明确双方权利义务，界定合作关系，共同恪守履行。</p>

          <h3 style="font-weight: 700; margin-top: 24px;">二、合作关系界定</h3>
          <p>1. 甲乙双方为<strong>平等民事合作关系</strong>，不存在任何劳动关系、劳务关系、劳务派遣关系及雇佣关系，无人身隶属与依附性。</p>
          <p>2. 乙方自主决定承接项目、安排工作时间与方式，独立完成服务，自负盈亏、自担风险，不受甲方考勤、考核、排班等劳动管理制度约束。</p>
          <p>3. 甲方无需为乙方缴纳社会保险、住房公积金，不承担乙方工资、福利、工伤、医疗等用人单位法定责任。</p>

          <h3 style="font-weight: 700; margin-top: 24px;">三、服务内容</h3>
          <p>1. 甲方为乙方提供<strong>项目信息撮合、订单对接、报酬结算、个税代扣代缴、业务咨询</strong>等平台配套服务，不参与乙方具体服务实施。</p>
          <p>2. 乙方自愿通过甲方平台承接适配项目，按需求方要求独立完成服务，对服务成果及合规性承担全部责任。</p>
          <p>3. 乙方承诺具备承接项目的合法资质与专业能力，不从事违法违规、损害甲方及需求方权益的行为。</p>

          <h3 style="font-weight: 700; margin-top: 24px;">四、报酬结算与税务处理</h3>
          <p>1. <strong>报酬核算</strong>：乙方服务经需求方验收合格后，甲方按平台标准核算服务报酬，该报酬为乙方服务全部对价，无工资薪金性质。</p>
          <p>2. <strong>结算支付</strong>：甲方按约定周期，扣除依法代缴/代征的个税及约定平台服务费后，将剩余报酬足额支付至乙方指定账户，不得无故克扣、拖欠。</p>
          <p>3. <strong>税务合规</strong>：乙方确认平台所得为劳务报酬所得，甲方依法办理个税申报缴纳手续，相关税费由乙方承担，从报酬中直接扣除，甲方可提供完税凭证佐证。乙方如存在多平台取得服务收入的，由各平台分别代为申报，并按照规定缴纳代办税费，乙方应依法自行办理个人所得税汇算清缴。因多平台收入合并计税导致需补缴的个人所得税、增值税及附加、滞纳金、罚款均由乙方自行承担，乙方逾期未交的，产生的滞纳金及其他责任由乙方自行承担；甲方也有权利直接从乙方收入中扣除实际产生的税收。</p>
          <p>4. 乙方需配合提供真实有效信息，协助完成税务及开票相关手续，信息变更需及时书面告知甲方。</p>

          <h3 style="font-weight: 700; margin-top: 24px;">五、双方权利与义务</h3>
          <p><strong>（一）甲方权利义务</strong></p>
          <p>1. 审核乙方身份及资质，监督乙方服务过程，对违规行为有权暂停结算、终止合作并追责。</p>
          <p>2. 保障平台正常运行，提供订单、结算、咨询等服务，妥善保管乙方信息，不得非法泄露。</p>
          <p>3. 按协议约定按时足额结算报酬，依法履行个税代征代缴义务。</p>
          <p><strong>（二）乙方权利义务</strong></p>
          <p>1. 自主选择承接平台项目，按约定获取服务报酬，查询结算及完税信息。</p>
          <p>2. 提供真实完整的身份、账户信息，因信息不实导致的损失由乙方自行承担。</p>
          <p>3. 服务过程中遵守法律法规，自行承担人身伤害、财产损失及相关法律责任，与甲方无关。</p>
          <p>4. 不得假借甲方名义从事非授权活动，不得损害甲方品牌声誉及合法权益。</p>

          <h3 style="font-weight: 700; margin-top: 24px;">六、协议期限</h3>
          <p>本协议自双方签字盖章之日起生效，有效期<strong>壹年</strong>。期满前30日双方无书面终止/变更意向，自动续期壹年，以此类推。乙方可书面申请终止协议，甲方审核无未结款项、无违规事项后，协议终止。</p>

          <h3 style="font-weight: 700; margin-top: 24px;">七、违约责任</h3>
          <p>1. 任何一方违约，需赔偿对方全部经济损失及名誉损失。</p>
          <p>2. 乙方提供虚假信息、违规服务、拒不配合税务工作或擅自违约，甲方有权扣除相应报酬作为违约金，不足弥补损失的可继续追偿。</p>
          <p>3. 甲方无故拖欠报酬、非法泄露乙方信息，需依法承担赔偿责任。</p>

          <h3 style="font-weight: 700; margin-top: 24px;">八、争议解决</h3>
          <p>因本协议产生的争议，双方友好协商解决；协商不成，提交<strong>甲方所在地</strong>人民法院诉讼解决。</p>

          <h3 style="font-weight: 700; margin-top: 24px;">九、其他条款</h3>
          <p>1. 本协议未尽事宜，可签订补充协议，补充协议与本协议具有同等法律效力。</p>
          <p>2. 本协议一式<strong>两份</strong>，甲乙双方各执一份，签字盖章后生效，具有同等法律效力。</p>
          <p>3. 乙方已仔细阅读并完全理解本协议全部条款，自愿签署，确认知晓合作关系性质及全部权责。</p>

          <p style="margin-top: 32px;"><strong>（以下无正文）</strong></p>

          <p style="margin-top: 24px;">甲方（盖章）：漯河捷泰信息科技有限公司</p>
          <p>日期：_________年____月____日</p>
          <p style="margin-top: 16px;">乙方（签字）：</p>
          <p>日期：_________年____月____日</p>
        </div>
      `,
    };
  },
};
</script>

<style scoped>
.protocol-content {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 30px;
  background: #fff;
}
</style>